export const SITE_NAME = "Zeek Maps";
export const SITE_URL =
	process.env.NODE_ENV === "development"
		? "http://127.0.0.1:8080"
		: process.env.NODE_ENV === "test"
			? "https://test.zeekmaps.com"
			: "https://zeekmaps.com";
export const SITE_API_URL =
	process.env.NODE_ENV === "development"
		? "http://127.0.0.1:8787"
		: process.env.NODE_ENV === "test"
			? "https://test-api.zeekmaps.com"
			: "https://api.zeekmaps.com";
export const SITE_DESCRIPTION = "Your live city maps.";
export const SITE_KEYWORDS = [
	"zeek maps",
	"maps",
	"city",
	"live",
	"city maps",
	"live city maps",
	"city maps live",
	"city maps live city maps",
];
export const SITE_LOGO = "/images/logo.png";
export const SITE_REPORT_EMAIL = "report@zeekmaps.com";
export const SITE_CONTACT_EMAIL = "contact@zeekmaps.com";
export const SITE_SUPPORT_EMAIL = "support@zeekmaps.com";
export const SITE_TWITTER_USERNAME = "@zeekmaps";
export const SITE_INSTAGRAM_USERNAME = "@zeekmaps";
export const SITE_LINKEDIN_USERNAME = "@zeekmaps";

// Zeek Labs
export const SITE_OWNER_URL = "https://zeeklabs.org";
export const SITE_OWNER_NAME = "Zeek Labs";
export const COMPANY_NAME = "ZEEK LABS (OPC) PRIVATE LIMITED";
export const COMPANY_NAME_FULL = "Zeek Labs Pvt. Ltd.";
export const PHONE_NUMBER_SITE = "+91 984585 8420";
export const COMPANY_ADDRESS =
	"WeWork Embassy, " +
	"\nBlock L, Devarabisanahalli, Bellandur, " +
	"\nBangalore South, Karnataka, " +
	"\nBangalore 560103, India";
export const COMPANY_ADDRESS_SHORT = "WeWork Embassy, Bengaluru";
export const COMPANY_ADDRESS_GMAPS_LINK =
	"https://maps.app.goo.gl/6zwJfuwHjZbcSQpq6";
export const OFFICES = {
	india: {
		company: {
			name: COMPANY_NAME_FULL,
			phone: PHONE_NUMBER_SITE,
			email: SITE_CONTACT_EMAIL,
		},
		bengaluru: {
			address: COMPANY_ADDRESS,
		},
	},
};
export const WHATSAPP_LINK =
	"https://wa.me/919845858420?text=Hi%21%20Lets%20Talk%21";
